module.exports = __webpack_public_path__ + "static/img/7.c7b3def.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/sp/7.png
// module id = oML5
// module chunks = 0